import React, { useContext, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

export default function OverrideRootElement() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [overrideRoot, setOverrideRoot] = useState('');
  const [overrideRootOptions, setOverrideRootOptions] = useState([]);

  const getRoots = (rootNode) => {
    let roots = [''];

    const loopRoot = (node) => {
      if (node.ICON_DISPLAY === "TEMPLATE_BODY_DOTS") node.children.forEach(o => loopRoot(o));
      if (["ELEMENT", "RECORD", "RECORD_TOP"].includes(node.ICON_DISPLAY)) {
        if(["ELEMENT", "RECORD"].includes(node.ICON_DISPLAY)) roots.push(node.DESCRIPTION || node.TYPE || node.title);
        if (node.children?.length) node.children.forEach(o => loopRoot(o));
      }
    }
    loopRoot(rootNode);
    return roots;
  }

  useEffect(() => {
    const treeData = rightTree.tree[rightTree.currentTab].translatedData[0];
    if (treeData && overrideRootOptions !== getRoots(treeData)) setOverrideRootOptions(getRoots(treeData));
  }, [rightTree.tree])

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    if (header.OVERRIDE_ROOT_ELEMENT) setOverrideRoot(overrideRootOptions.includes(header.OVERRIDE_ROOT_ELEMENT) ? header.OVERRIDE_ROOT_ELEMENT : '');
    else setOverrideRoot('');
  }, [overrideRootOptions])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({screen: parentScreen, key, value}));
  }



  return (
    <>
      <FormControl size="small" variant="outlined" className="width-100">
        <InputLabel id="overrideDropdownLabel">{t('LBL_XML_OVR_ROOT_ELEM')}</InputLabel>
        <Select
          className="width-100"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 250
              }
            }
          }}
          labelId="overrideDropdownLabel"
          id="overrideDropdown"
          value={overrideRoot}
          onChange={(e) => {
            setOverrideRoot(e.target.value);
            handleChange('OVERRIDE_ROOT_ELEMENT', e.target.value);
          }}
          label={t('LBL_GROUP_BY_REC_NAME')}
        >
          {/* map options, display list based on the datatype */}
          {overrideRootOptions.map((o, k) => (
            <MenuItem key={"override-" + k} value={o}>
              {!k ? (
                <span style={{ height: 18 }}></span>
              ) : rightTree.tree.templateHeader.FILETYPE === "XML" ? (
                <div className="flex align-center">
                  {o.includes('<') ? o : `<${o}>`}
                </div>
              ) : k === 1 ? (
                <div className="flex align-center">
                  {o}
                </div>
              ) : (
                <div className="flex align-center">
                  {o}
                </div>
              )}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  )
}